export const updateNewPosting = 'updateNewPosting';
export const updateIsAddPostingClicked = 'updateIsAddPostingClicked';
export const updatePostings = "updatePostings";
export const updateIsEditPostingClicked = "updateIsEditPostingClicked";
export const updatePostingsDataTable = "updatePostingsDataTable";
export const updateIsViewPostingClicked = "updateIsViewPostingClicked"